export default __webpack_public_path__ + "static/media/AIFeatures.fca517f1.png";